import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ClientEmailEmptyError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.client-email.is-empty');
    }
}
